import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { getCurrentUser } from "../services/utilisateurs";
import type { Utilisateur } from "../types/utilisateur";
import "./Dashboard.css";
import logo from "../assets/congelcam-logo.png";

import GestionUtilisateurs from "../components/childsuperadmin/GestionUtilisateurs";

export default function DashboardSuperAdmin() {
  const [user, setUser] = useState<Utilisateur | null>(null);
  const [activeMenu, setActiveMenu] = useState("Gestion des utilisateurs");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("role");
    navigate("/");
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await getCurrentUser();
        setUser(data);
      } catch (err) {
        console.error("Erreur récupération profil :", err);
      }
    };
    fetchUser();
  }, []);

  if (!user) return <p>Chargement...</p>;

  const renderContent = () => {
    switch (activeMenu) {
      case "Gestion des utilisateurs":
        return <GestionUtilisateurs />;
      case "Tableau de bord":
        return <p>Bienvenue sur le tableau de bord</p>;
      case "Entrepôts":
        return <p>Module Entrepôts en développement</p>;
      case "Chambres froides":
        return <p>Module Chambres froides en développement</p>;
      case "Groupes frigorifiques":
        return <p>Module Groupes frigorifiques en développement</p>;
      case "Relèves":
        return <p>Module Relèves en développement</p>;
      case "Seuils":
        return <p>Module Seuils en développement</p>;
      case "Alertes":
        return <p>Module Alertes en développement</p>;
      case "Paramètres":
        return <p>Module Paramètres en développement</p>;
      default:
        return <p>Sélectionnez un menu</p>;
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar {...user} activeMenu={activeMenu} setActiveMenu={setActiveMenu} onLogout={handleLogout} />
      <main className="dashboard-main">
        <div className="dashboard-header">
          <h1 className="dashboard-title">{activeMenu}</h1>
          <img src={logo} alt="Congelcam Logo" className="dashboard-logo" />
        </div>
        {renderContent()}
      </main>
    </div>
  );
}
